import React, { useMemo } from 'react';
import { capitalize, toLower } from 'lodash';
import PdfSection from 'Views/Pages/Pdf/Components/PDFSection';
import {
	DuplicateCourseItem,
} from 'Views/Pages/Frontend/StudyPlanWizard/RequirementFulfilmentCheck/DuplicateCourseSelection';
import PdfCourseAccordion from 'Views/Pages/Pdf/Components/PDFCourseAccordion';
import PdfCourseAccordionItem from 'Views/Pages/Pdf/Components/PDFCourseAccordionItem';
import PdfChipGroup from 'Views/Pages/Pdf/Chip/PDFChipGroup';
import PdfChip from 'Views/Pages/Pdf/Chip/PdfChip';
import { CourseEntity } from 'Models/Entities';

interface DuplicateCourseSelectionProps {
	description?: string,
	duplicateCourses: DuplicateCourseItem[]
	completedCourseIds: string[],
}

const DuplicateCourseSelection = (props: DuplicateCourseSelectionProps) => {
	const {
		duplicateCourses,
		completedCourseIds,
		description,
	} = props;

	const sortedCourses = useMemo(
		() => [...duplicateCourses]
			.sort((a, b) => a.course.code.localeCompare(b.course.code)),
		[duplicateCourses],
	);

	return (
		<PdfSection
			title={
				window.lexicon.duplicateSelectionSummary
					? `${capitalize(window.lexicon.duplicateSelectionSummary)}`
					: 'Duplicate Selection Summary'
			}
			description={description}
			showDivider={false}
		>
			<PdfCourseAccordion<DuplicateCourseItem>
				title={`${toLower(window.lexicon.duplicate)} ${toLower(window.lexicon.courses)}`}
				depth={0}
				items={sortedCourses}
				emptyLabel={`No ${toLower(window.lexicon.duplicate)} ${toLower(window.lexicon.courses)}`}
				renderItem={(item, index) => {
					const course = new CourseEntity(item.course);

					return (
						<PdfCourseAccordionItem
							course={course}
							label={(
								<PdfChipGroup>{
									item.displayComponents.map(component => (
										<PdfChip label={component.displayName} />
									))
								}
								</PdfChipGroup>
							)}
							additionalStatus={
								completedCourseIds.includes(course.id)
									? (
										<PdfChipGroup>
											<PdfChip label={'Completed/Credit'} isSuccess />
										</PdfChipGroup>
									)
									: null
							}
						/>
					);
				}}
			/>
		</PdfSection>
	);
};

export default DuplicateCourseSelection;
